import { useState, useEffect, useCallback } from 'react';
import { renewalsAPI } from '../services/api';

export function useAutoRenewal(policyId) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!policyId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await renewalsAPI.getSettings(policyId);
      setSettings(data?.data ?? data ?? null);
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Failed to load settings');
      setSettings(null);
    } finally {
      setLoading(false);
    }
  }, [policyId]);

  useEffect(() => {
    load();
  }, [load]);

  const update = useCallback(async (body) => {
    if (!policyId) return null;
    try {
      const data = await renewalsAPI.updateSettings(policyId, body);
      const next = data?.data ?? data ?? null;
      setSettings(next);
      return next;
    } catch (e) {
      throw e;
    }
  }, [policyId]);

  return { settings, loading, error, reload: load, update };
}
